import { NgClass, NgStyle } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import { MatMenuItem } from '@angular/material/menu';

import { Account } from '@shared/models/account';
import { SortPipe } from '@shared/pipes/sort.pipe';

@Component({
  selector: 'app-account-picker',
  templateUrl: './account-picker.component.html',
  styleUrls: ['./account-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, NgStyle, MatMenuItem, SortPipe]
})
export class AccountPickerComponent {
  readonly accounts = input.required<Account[]>();
  readonly selectedAccountId = input.required<string>();
  readonly disabled = input.required<boolean>();

  readonly selected = output<Account>();

  onAccountChange(account: Account): void {
    this.selected.emit(account);
  }
}
